import { Component, OnInit } from '@angular/core';
import { MsgCompraComponent } from '../msg-compra/msg-compra.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pgto-ok',
  templateUrl: './pgto-ok.component.html',
  styleUrls: ['./pgto-ok.component.scss']
})
export class PgtoOkComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PgtoOkComponent>,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    //this.openMsg(true, 'Transação realizada com sucesso');
  }

//   openMsg(success, msg): void {
//   const isMobileResolution = window.innerWidth < 768 ? true : false;

//   const dialogRefMsg = this.dialog.open(MsgCompraComponent, {
//     width: isMobileResolution ? '98%' : '30vw',
//     data: { success, msg },
//     autoFocus: false
//   });

//   dialogRefMsg.afterClosed().subscribe(result => {
//     if (result) this.dialogRef.close(true);
//   });
// }


}
